import { ReduxUtils } from '../dependencies';

export const Toggles = ReduxUtils.strictObjectAccess({
    SEARCH_BAR: 'SEARCH_BAR',
});
